<template>
    <div class="incoming glass-theme">
        <!-- API Loading Overlay with Animation -->
        <transition name="loading-overlay">
            <div v-if="apiLoading" class="loading-overlay">
                <div class="loading-card">
                    <div class="loading-animation">
                        <div class="loading-ring">
                            <div class="ring"></div>
                            <div class="ring"></div>
                            <div class="ring"></div>
                            <div class="loading-logo">
                                <i class="fas fa-boxes"></i>
                            </div>
                        </div>
                    </div>
                    <div class="loading-text">
                        <h3>{{ loadingMessage }}</h3>
                        <div class="loading-dots">
                            <span class="dot"></span>
                            <span class="dot"></span>
                            <span class="dot"></span>
                        </div>
                    </div>
                    <div class="loading-progress">
                        <div class="progress-bar" :style="{ width: loadingProgress + '%' }"></div>
                    </div>
                    <div class="loading-tips">
                        <p class="tip-text">{{ currentTip }}</p>
                    </div>
                </div>
            </div>
        </transition>

        <!-- Comments Modal -->
        <b-modal id="modal-comments" scrollable size="md" hide-footer :title="'COMMENTS FOR ('+item_comments_invoice_id+')'">
            <ItemComments :viewdata="{invoice_id: item_comments_invoice_id, itemid: item_comments_itemid, username: packet.userDetails.username}" />
        </b-modal>

        <div style="width: 100%;">
            <!-- Filter Controls -->
            <div style="width: 100%;">
                <div class="d-flex flex-wrap" style="gap: 10px;">
                    <b-alert variant="secondary" show class="glass-alert" style="display: inline-block; vertical-align: top;">
                        <div style="display: inline-block; vertical-align: top;">
                            <b-button variant="success" style="display: inline-block;" size="sm" @click="fetchAllOrders" class="glass-btn">
                                SHOW ALL ORDERS
                            </b-button>
                        </div>
                    </b-alert>

                    <!-- Date Filter Section - Always show when we have orders -->
                    <div
                      v-if="isMobile && items.length > 0"
                      class="d-flex justify-content-between align-items-center mb-2 px-1"
                    >
                      <b-button
                        size="sm"
                        variant="outline-primary"
                        @click="filtersVisible = !filtersVisible"
                        class="glass-filter-btn"
                      >
                        <b-icon-funnel-fill class="mr-1" />
                        {{ filtersVisible ? 'Hide Filters' : 'Show Filters' }}
                      </b-button>
                    </div>

                    <b-collapse :visible="!isMobile || filtersVisible">

                      <!-- FIRST BLOCK -->
                      <b-alert
                        variant="info"
                        show
                        style="display: inline-block; margin-top: 0px;"
                        v-if="allOrders.length > 0"
                        class="glass-filters"
                      >
                        <div style="display: flex; flex-wrap: wrap; gap: 10px; align-items: center;">
                          <div style="display: inline-block;">
                            <b-form-select
                              v-model="selectedDate"
                              :options="availableDates"
                              size="sm"
                              style="width: 200px;"
                              @change="onDateSelected"
                              class="glass-select"
                            >
                            </b-form-select>
                          </div>
                        </div>
                      </b-alert>

                      <!-- SECOND BLOCK -->
                      <b-alert
                        variant="primary"
                        show
                        style="display: inline-block; vertical-align: top; padding: 13px;"
                        v-if="allOrders.length > 0"
                        class="glass-filters"
                      >
                        <div style="display: flex; flex-wrap: wrap; gap: 10px; align-items: center;">

                          <div style="display: inline-block;">
                            <b-form-select
                              v-model="selected_state"
                              :options="availableStatusOptions"
                              size="sm"
                              style="width: 150px;"
                              class="glass-select"
                            ></b-form-select>
                          </div>

                          <div style="display: inline-block;">
                            <b-form-select
                              v-model="picked_pickup_truck"
                              :options="availableTrucks"
                              size="sm"
                              style="width: 150px;"
                              class="glass-select"
                            ></b-form-select>
                          </div>

                          <div style="display: inline-block;">
                            <b-form-select
                              v-model="selectedPickLocation"
                              :options="availablePickLocations"
                              size="sm"
                              style="width: 200px;"
                              class="glass-select"
                            ></b-form-select>
                          </div>

                          <div style="display: inline-block;">
                            <b-form-select
                              v-model="selectedDropLocation"
                              :options="availableDropLocations"
                              size="sm"
                              style="width: 200px;"
                              class="glass-select"
                            ></b-form-select>
                          </div>

                          <div style="display: inline-block;">
                            <b-form-select
                              v-model="selectedOrderType"
                              :options="availableOrderTypes"
                              size="sm"
                              style="width: 180px;"
                              class="glass-select"
                            ></b-form-select>
                          </div>

                        </div>
                      </b-alert>

                    </b-collapse>

                    <!-- Show message when no orders found -->
                    <b-alert variant="warning" show style="display: inline-block; margin-top: 10px; margin-left: 10px;"
                             v-if="allOrders.length > 0 && filteredItems.length === 0" class="glass-empty-alert">
                        <h6 style="margin-bottom: 0;">No orders found for the selected filters</h6>
                    </b-alert>
                </div>
            </div>
        </div>

        <!-- Data Display -->
        <div style="width: 100%; padding: 5px; min-height: 200px;">
            <div>
                <div v-if="items_being_loaded == true">
                    <loading
                        :active="true"
                        :can-cancel="false"
                        :is-full-page="false">
                    </loading>
                </div>
                <div v-else>
                    <!-- Show items when filtered -->
                    <div v-if="filteredItems.length > 0" class="diver">
                        <table style="width:100%;" class="glass-table">
                            <thead>
                                <tr style="font-size: 14px; text-align: center;">
                                    <th class="srr glass-table-header" style="width: 100px;" @click="sortby('invoice_id')">
                                        INVOICE #
                                    </th>
                                    <th class="srr glass-table-header" style="width: 100px;">
                                        DELIVERY DATE
                                    </th>
                                    <th class="srr glass-table-header" style="width: 130px;">
                                        OUTGOING TYPE
                                    </th>
                                    <th class="srr glass-table-header" style="width: 100px;" @click="sortby('product_sku')">
                                        PRD SKU
                                    </th>
                                    <th class="srr glass-table-header" style="width: 250px;" @click="sortby('product_name')">
                                        PRD NAME
                                    </th>
                                    <th class="srr glass-table-header" style="width: 70px;" @click="sortby('order_type')">
                                        ORDER TYPE
                                    </th>
                                    <th class="srr glass-table-header" style="width: 30px;" @click="sortby('quantity')">
                                        QTY
                                    </th>
                                    <th class="srr glass-table-header" style="width: 180px;" @click="sortby('ship_locsub')">
                                        PICK LOCATION
                                    </th>
                                    <th class="srr glass-table-header" style="width: 180px;" @click="sortby('drop_location')">
                                        DROP LOCATION
                                    </th>
                                    <th class="srr glass-table-header" style="width: 180px;" @click="sortby('drop_location')">
                                        DELIVERY LOCATION
                                    </th>
                                    <th class="srr glass-table-header" @click="sortby('pickup_truck')" style="width: 80px;">
                                        PICKUP TRUCK
                                    </th>
                                    <th class="srr glass-table-header" style="width: 120px;" @click="sortby('state')">
                                        STATUS
                                    </th>
                                    <th style="width: 80px;" class="srr glass-table-header">
                                        ACTION
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, idx) in filteredItems" :key="idx" v-if="allowed(item)" class="glass-table-row">
                                    <td class="srrv">
                                        {{ item.invoice_id }}
                                    </td>
                                    <td class="srrv">
                                        {{ item.delivery_date }}
                                    </td>
                                    <td class="srrv">
                                        {{ outgoing_type_dict[item.outgoing_type] }}
                                    </td>
                                    <td class="srrv">
                                        {{ item.product_sku }}
                                    </td>
                                    <td class="srrv">
                                        {{ item.product_name }}
                                    </td>
                                    <td class="srrv">
                                        <div v-if="item.order_type == 'home_delivery'">
                                            <b-alert show variant="primary" style="padding: 2px; font-size: 12px; text-align: center;">HOME DLVRY</b-alert>
                                        </div>
                                        <div v-else-if="item.order_type == 'store_pickup'">
                                            <b-alert show variant="warning" style="padding: 2px; font-size: 12px; text-align: center;">STORE PICKUP</b-alert>
                                        </div>
                                        <div v-else-if="item.outgoing_type == 'STORE_TRANSFER_ORDER'">
                                            <b-alert show variant="info" style="padding: 2px; font-size: 11px; text-align: center;">STORE TRANSFER</b-alert>
                                        </div>
                                        <div v-else-if="item.outgoing_type == 'DAMAGE_ORDER'">
                                            <b-alert show variant="secondary" style="padding: 2px; font-size: 11px; text-align: center;">DAMAGE ORDER</b-alert>
                                        </div>
                                    </td>
                                    <td class="srrv">
                                        {{ item.quantity }}
                                    </td>
                                    <td class="srrv">
                                      {{packet.locsubsdict[item.original_locsub]}}
                                    </td>
                                    <td class="srrv">
                                       {{packet.locsubsdict[item.ship_locsub]}}
                                    </td>
                                    <td class="srrv">
                                       {{packet.locsubsdict[item.drop_locsub]}}
                                    </td>
                                    <td class="srrv">
                                        <span v-if="outgoing_type == 'as_store_transfer_order'">
                                                 {{ item.truck }}
                                        </span>
                                        <span v-else :class="{ 'text-danger': !isTruckAssigned(item) }">
                                            {{ getTruckDisplay(item) }}
                                        </span>
                                    </td>
                                    <td class="srrv">
                                        <b-form-select
                                            size="sm"
                                            :options="getAvailableStates(item)"
                                            v-model="item.state"
                                            v-on:change="update_invoice_item_state(item)"
                                            :disabled="packet.locsubsdict[item.locsub] == 'OUT OF STOCK | OUT OF STOCK' || isStateDisabled(item, item.state)"
                                            class="glass-status-select"
                                        >
                                            <template #first>
                                                <b-form-select-option :value="item.state" disabled>
                                                    {{ getStateDisplayText(item.state) }}
                                                </b-form-select-option>
                                            </template>
                                        </b-form-select>
                                    </td>
                                    <td class="srrv hidden-print">
                                        <button class="glass-comment-btn" @click="show_comments(item)">CMNT</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <!-- Show message when no items match filters -->
                    <div v-if="allOrders.length > 0 && filteredItems.length === 0" class="text-center p-4">
                        <b-alert variant="warning" show class="glass-empty-alert">
                            <h5>No orders found for the selected filters</h5>
                            <p>
                                Date: {{ selectedDate || 'All Dates' }} |
                                Status: {{ selected_state === 'open' ? 'ALL' : (selected_state ? getStateDisplayText(selected_state) : 'All Status') }} |
                                Truck: {{ picked_pickup_truck ? (packet.trucksdict[picked_pickup_truck] || picked_pickup_truck) : 'All Trucks' }} |
                                Pick Location: {{ selectedPickLocation ? getLocationDisplay(selectedPickLocation) : 'All Pick Locations' }} |
                                Drop Location: {{ selectedDropLocation ? getLocationDisplay(selectedDropLocation) : 'All Drop Locations' }} |
                                Order Type: {{ selectedOrderType ? getOrderTypeDisplay(selectedOrderType) : 'All Order Types' }}
                            </p>
                        </b-alert>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import DatePicker from 'vue2-datepicker';
    import moment from 'moment'
    import mappings from '@/utilities/mappings'
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';
    import Requestor from '@/utilities/Requestor';
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import { BIconFunnelFill } from 'bootstrap-vue'

    import ItemComments from '@/components/importables/ItemComments'

    export default {
        name: "Incoming",
        components: { flatPickr, Loading, ItemComments, DatePicker },
        data: function() {
            let out = {
                // Original data properties
                items: [],
                dates: [],
                active_date: null,
                years: [
                    {value: 2022, text: 2022},
                    {value: 2023, text: 2023},
                    {value: 2024, text: 2024},
                    {value: 2025, text: 2025},
                    {value: 2026, text: 2026},
                    {value: 2027, text: 2027},
                    {value: 2028, text: 2028},
                    {value: 2029, text: 2029},
                    {value: 2030, text: 2030},
                ],
                months: [
                    {value: 1, text: 1},
                    {value: 2, text: 2},
                    {value: 3, text: 3},
                    {value: 4, text: 4},
                    {value: 5, text: 5},
                    {value: 6, text: 6},
                    {value: 7, text: 7},
                    {value: 8, text: 8},
                    {value: 9, text: 9},
                    {value: 10, text: 10},
                    {value: 11, text: 11},
                    {value: 12, text: 12},
                ],
                picked_outgoing_type: null,
                year: null,
                month: null,
                picked_date: null,
                picked_location_id: null,
                picked_pickup_truck: null,
                picked_delivery_truck: null,
                packet: {},
                items_being_loaded: false,
                dates_being_loaded: false,
                current_date: null,
                type: 'incoming',
                locsubs: [],
                locsub: null,

               states: [
            {"value": 0, "text": "ORDERED"},
            {"value": 2, "text": "PULLED"},
            {"value": -2, "text": "CANT PULL"},

            //pickup truck
            {"value": 3, "text": "PICKED"},
            {"value": -3, "text": "CANT PICK"},

            // pick up truck
            {"value": 30, "text": "DROPPED"},
            {"value": -30, "text": "CANNOT BE DROPPED"},

            {"value": 9, "text": "RECEIVED FROM WAREHOUSE"},
            {"value": -9, "text": "CANNOT RECEIVED FROM WAREHOUSE"},

            {"value": 10, "text": "DISPATCHED FOR STORE"},
            {"value": -10, "text": "CANNOT BE DISPATCHED FOR STORE"},

            {"value": 11, "text": "PICKED FROM MECCA SHIPPING"},
            {"value": -11, "text": "CANNOT BE PICKED FROM MECCA SHIPPING"},

            {"value": 13, "text": "DROPPED AT STORE"},
            {"value": -13, "text": "CANNOT BE DROPPED AT STORE"},

            //people who receive items from pickup truck
            {"value": 4, "text": "RECEIVED"},
            {"value": -4, "text": "CANT RECEIVE"},

            //people who make it ready to ship
            {"value": 5, "text": "READY TO SHIP"},
            {"value": -5, "text": "CANT READY TO SHIP"},

            //poeple who load it into delivery trucks
            {"value": 6, "text": "LOADED FOR DELIVERY"},
            {"value": -6, "text": "CANT BE LOADED FOR DELIVERY"},

            //truck driver who confirms that item is in truck for delivery
            {"value": 12, "text": "SHIPPED FOR DELIVERY"},
            {"value": -12, "text": "CANT BE SHIPPED FOR DELIVERY"},

            //truck driver who delivers the item
            {"value": 1, "text": "DELIVERED"},
            {"value": -7, "text": "CANT DELIVER"},
            {"value": -8, "text": "NEEDS ATTENTION"}
        ],
                states_outgoing_current: mappings.states,
                states_outgoing_new: mappings.states,
                states_dict: mappings.states_dict,
                item_comments_invoice_id: null,
                item_comments_itemid: null,
                comments_dict: {},
                date_range: [],
                picked_date_range: null,
                trucks: [],
                location_id: null,
                outgoing_options: [
                    {value: "as_delivery", text: "AS DELIVERY / CUSTOMER PICKUP"},
                    {value: "as_store_transfer_order", text: "AS STORE TRANSFER ORDER"},
                ],
                outgoing_type_dict: {
                    "CUSTOMER_ORDER": "CUSTOMER ORDER",
                    "STORE_TRANSFER_ORDER": "STORE TRANSFER ORDER",
                     "DAMAGE_ORDER": "DAMAGE ORDER",
                },
                outgoing_type: null,
                selected_state: null,

                // New filter data properties
                allOrders: [],
                selectedDate: null,
                selectedPickLocation: null,
                selectedDropLocation: null,
                selectedOrderType: null,
                // Available options for filters
                availableDates: [],
                availableTrucks: [],
                availablePickLocations: [],
                availableDropLocations: [],
                filtersVisible: false,
                isMobile: false,
                // Loading animation properties
                apiLoading: false,
                loadingMessage: 'Loading Outgoing Items',
                loadingProgress: 0,
                currentTipIndex: 0,
                loadingInterval: null,
                tipInterval: null,
                msgInterval: null,
                apiCallStack: 0,
                tips: [
                    "📦 Fetching outgoing items...",
                    "🚚 Loading delivery schedules...",
                    "📍 Syncing location data...",
                    "📊 Processing orders...",
                    "🔄 Updating inventory...",
                    "✨ Organizing items...",
                    "📈 Preparing data..."
                ]
            }
            return out;
        },
        mounted: function() {
          this.handleResize();
          window.addEventListener('resize', this.handleResize);
        },
        beforeDestroy() {
          window.removeEventListener('resize', this.handleResize);
        },
        computed: {
             availableOrderTypes() {
        const orderTypeCounts = {};
        let filteredItems = this.allOrders;

        // Apply current filters except order type filter
        if (this.selectedDate) {
            filteredItems = filteredItems.filter(item => item.delivery_date === this.selectedDate);
        }
        if (this.selected_state === 'open') {
            filteredItems = filteredItems.filter(item => item.status !== 1);
        } else if (this.selected_state) {
            filteredItems = filteredItems.filter(item => item.state == this.selected_state);
        }
        if (this.picked_pickup_truck) {
            filteredItems = filteredItems.filter(item => {
                const itemTruck = item.pickup_truck || item.truck;
                return itemTruck == this.picked_pickup_truck;
            });
        }
        if (this.selectedPickLocation) {
            filteredItems = filteredItems.filter(item => String(item.ship_locsub) === String(this.selectedPickLocation));
        }
        if (this.selectedDropLocation) {
            filteredItems = filteredItems.filter(item => String(item.drop_location) === String(this.selectedDropLocation));
        }

        filteredItems.forEach(order => {
            let orderType = order.order_type;

            // Handle store transfer orders
            if (order.outgoing_type === 'STORE_TRANSFER_ORDER') {
                orderType = 'store_transfer';
            }

            if (orderType) {
                if (!orderTypeCounts[orderType]) {
                    orderTypeCounts[orderType] = 0;
                }
                orderTypeCounts[orderType]++;
            }
        });

        const orderTypeOptions = Object.keys(orderTypeCounts)
            .map(orderType => {
                let displayText = '';
                let count = orderTypeCounts[orderType];

                switch(orderType) {
                    case 'home_delivery':
                        displayText = `HOME DELIVERY (${count})`;
                        break;
                    case 'store_pickup':
                        displayText = `STORE PICKUP (${count})`;
                        break;
                    case 'store_transfer':
                        displayText = `STORE TRANSFER (${count})`;
                        break;
                    default:
                        displayText = `${orderType.toUpperCase().replace('_', ' ')} (${count})`;
                }

                return {
                    value: orderType,
                    text: displayText,
                    count: count
                };
            })
            .sort((a, b) => b.count - a.count);

        return [
            { value: null, text: '-- ALL ORDER TYPES --' },
            ...orderTypeOptions
        ];
    },
        availableStatusOptions() {
        // Get count of each state in current filtered items
        const stateCounts = {};
        this.filteredItems.forEach(item => {
            stateCounts[item.state] = (stateCounts[item.state] || 0) + 1;
        });

        // Create options for the status filter
        const options = [
            { value: 'open', text: 'ALL' }
        ];

        // Add states that exist in current data
        Object.keys(stateCounts).forEach(state => {
            const stateValue = parseInt(state);
            const stateObj = this.states.find(s => s.value === stateValue);
            if (stateObj && stateCounts[stateValue] > 0) {
                options.push({
                    value: stateValue,
                    text: `${stateObj.text} (${stateCounts[stateValue]})`
                });
            }
        });

        return options;
    },
           filteredItems() {
        let filtered = this.allOrders;

        // Filter by selected date
        if (this.selectedDate) {
            filtered = filtered.filter(item => item.delivery_date === this.selectedDate);
        }

        // Filter by state
        if (this.selected_state === 'open') {
            filtered = filtered.filter(item => item.status !== 1);
        } else if (this.selected_state) {
            filtered = filtered.filter(item => item.state == this.selected_state);
        }

        // Filter by pickup truck
        if (this.picked_pickup_truck) {
            filtered = filtered.filter(item => {
                const itemTruck = item.pickup_truck || item.truck;
                return itemTruck == this.picked_pickup_truck;
            });
        }

        // Filter by pick location
        if (this.selectedPickLocation) {
            filtered = filtered.filter(item => {
                const itemPickLocation = String(item.ship_locsub);
                const selectedPickLocation = String(this.selectedPickLocation);
                return itemPickLocation === selectedPickLocation;
            });
        }

        // Filter by drop location
        if (this.selectedDropLocation) {
            filtered = filtered.filter(item => {
                const itemDropLocation = String(item.drop_location);
                const selectedDropLocation = String(this.selectedDropLocation);
                return itemDropLocation === selectedDropLocation;
            });
        }

        // ADD THIS: Filter by order type
        if (this.selectedOrderType) {
            filtered = filtered.filter(item => {
                if (this.selectedOrderType === 'store_transfer') {
                    return item.outgoing_type === 'STORE_TRANSFER_ORDER';
                } else {
                    return item.order_type === this.selectedOrderType;
                }
            });
        }

        return filtered;
    }
        },
        methods: {
            // Loading animation methods
            startApiLoading(message = 'Loading Outgoing Items') {
                this.apiCallStack++;
                if (!this.apiLoading) {
                    this.startLoadingAnimation(message);
                } else {
                    this.loadingMessage = message;
                }
            },
            stopApiLoading() {
                this.apiCallStack--;
                if (this.apiCallStack <= 0 && this.apiLoading) {
                    this.stopLoadingAnimation(true);
                }
            },
            startLoadingAnimation(message = 'Loading Outgoing Items') {
                this.apiLoading = true;
                this.loadingMessage = message;
                this.loadingProgress = 0;
                this.currentTipIndex = 0;
                
                this.loadingInterval = setInterval(() => {
                    if (this.loadingProgress < 90) {
                        this.loadingProgress += Math.random() * 10;
                        if (this.loadingProgress > 90) this.loadingProgress = 90;
                    }
                }, 300);
                
                this.tipInterval = setInterval(() => {
                    if (this.currentTipIndex < this.tips.length - 1) {
                        this.currentTipIndex++;
                    }
                }, 2000);
                
                let messages = ['Loading Items', 'Fetching Data', 'Processing Records', 'Updating List', 'Finalizing'];
                let msgIndex = 0;
                this.msgInterval = setInterval(() => {
                    if (msgIndex < messages.length - 1) {
                        msgIndex++;
                        this.loadingMessage = messages[msgIndex];
                    }
                }, 1800);
            },
            stopLoadingAnimation(success = true) {
                if (this.loadingInterval) clearInterval(this.loadingInterval);
                if (this.tipInterval) clearInterval(this.tipInterval);
                if (this.msgInterval) clearInterval(this.msgInterval);
                
                if (success) {
                    this.loadingProgress = 100;
                    setTimeout(() => {
                        this.apiLoading = false;
                    }, 500);
                } else {
                    this.apiLoading = false;
                }
            },

            handleResize() {
              this.isMobile = window.innerWidth < 768;
            },
            getOrderTypeDisplay(orderType) {
    switch(orderType) {
        case 'home_delivery':
            return 'Home Delivery';
        case 'store_pickup':
            return 'Store Pickup';
        case 'store_transfer':
            return 'Store Transfer';
        default:
            return orderType ? orderType.toUpperCase().replace('_', ' ') : 'All Order Types';
    }
},
            // MISSING METHOD - Add this
            allowed: function(item) {
                // Defensive check - if item is malformed, don't show it
                if (!item || typeof item !== 'object') {
                    return false;
                }

                let status = true;
                let filtered_states = this.filtered_states(item);
                let allowed_item = this.allowed_item(item);
                let filtered_pickup_truck = this.filtered_pickup_truck(item);
                let filtered_delivery_truck = this.filtered_delivery_truck(item);

                // Safe location display with null checks
                const shipLoc = item.ship_locsub || null;
                const dropLoc = item.drop_locsub || null;
                const dropLocation = this.getLocationDisplay(shipLoc);
                const deliveryLocation = this.getLocationDisplay(dropLoc);

                if (dropLocation === "MECCA SHIPPING" && deliveryLocation === "MECCA SHIPPING") {
                    status = false;
                    return status;
                }

                return status && filtered_states && allowed_item && filtered_pickup_truck && filtered_delivery_truck;
            },

            // Other existing methods
            filtered_states: function(item) {
                let status = true;
                if (this.selected_state && this.selected_state == "open") {
                    if (item.status !== 1) {
                        status = true;
                    } else {
                        status = false;
                    }
                } else if (this.selected_state && this.selected_state != "open") {
                    if (item.state == this.selected_state) {
                        status = true;
                    } else {
                        status = false;
                    }
                }
                return status;
            },

            allowed_item: function(item) {
                let status = true;
                let userrole = this.packet.userDetails.userrole;

                // Use the correct property name and set to null if not found
                let item_location_id = item.drop_location || item.drop_locsub || item.ship_locsub || null;

                // If user is admin/office user, always allow
                if (userrole == "admin" || userrole == "officeuser" || userrole == "officemanager") {
                    return true;
                }

                // Check if user has properties and location_id
                if (this.packet.userDetails.properties && this.packet.userDetails.properties.location_id) {
                    let user_location_id = parseInt(this.packet.userDetails.properties.location_id);
                    let item_loc = item_location_id ? parseInt(item_location_id) : null;

                    // If item has no location or matches user's location, allow it
                    if (item_loc === null || user_location_id === item_loc) {
                        status = true;
                    } else {
                        status = false;
                    }
                } else {
                    // If user has no location_id in properties, don't allow any items
                    status = true;
                }

                return status;
            },

            filtered_pickup_truck: function(item) {
                let status = true;
                if (this.picked_pickup_truck) {
                    const itemTruck = item.pickup_truck || item.truck;
                    if (itemTruck == this.picked_pickup_truck) {
                        status = true;
                    } else {
                        status = false;
                    }
                }
                return status;
            },

            filtered_delivery_truck: function(item) {
                let status = true;
                if (this.picked_delivery_truck) {
                    if (item.truck == this.picked_delivery_truck) {
                        status = true;
                    } else {
                        status = false;
                    }
                }
                return status;
            },

            // New methods for filter management
            onDateSelected(date) {
                this.selectedDate = date;
                this.updateAvailableFilterOptions();
            },

            clearAllFilters() {
    this.selectedDate = null;
    this.selected_state = null;
    this.picked_pickup_truck = null;
    this.selectedPickLocation = null;
    this.selectedDropLocation = null;
    this.selectedOrderType = null; // Add this line
},

            updateAvailableFilterOptions() {
                // Update available options based on current filters
                this.processAvailableDates();
                this.processAvailableTrucks();
                this.processAvailablePickLocations();
                this.processAvailableDropLocations();

            },

            processAvailableDates() {
                const dateCounts = {};
                this.allOrders.forEach(order => {
                    const date = order.delivery_date;
                    if (date) {
                        if (!dateCounts[date]) {
                            dateCounts[date] = 0;
                        }
                        dateCounts[date]++;
                    }
                });

                const sortedDates = Object.keys(dateCounts)
                    .map(date => ({
                        value: date,
                        text: `${date} (${dateCounts[date]} orders)`,
                        count: dateCounts[date]
                    }))
                    .sort((a, b) => new Date(b.value) - new Date(a.value));

                this.availableDates = [
                    { value: null, text: '-- ALL DATES --' },
                    ...sortedDates
                ];
            },

            processAvailableTrucks() {
                const truckCounts = {};
                let filteredItems = this.allOrders;

                // Apply current filters except truck filter
                if (this.selectedDate) {
                    filteredItems = filteredItems.filter(item => item.delivery_date === this.selectedDate);
                }
                if (this.selected_state === 'open') {
                    filteredItems = filteredItems.filter(item => item.status !== 1);
                } else if (this.selected_state) {
                    filteredItems = filteredItems.filter(item => item.state == this.selected_state);
                }
                if (this.selectedPickLocation) {
                    filteredItems = filteredItems.filter(item => String(item.ship_locsub) === String(this.selectedPickLocation));
                }
                if (this.selectedDropLocation) {
                    filteredItems = filteredItems.filter(item => String(item.drop_location) === String(this.selectedDropLocation));
                }

                filteredItems.forEach(order => {
                    const truck = order.pickup_truck || order.truck;
                    if (truck && truck !== '0' && truck !== 'null') {
                        const truckKey = String(truck);
                        if (!truckCounts[truckKey]) {
                            truckCounts[truckKey] = 0;
                        }
                        truckCounts[truckKey]++;
                    }
                });

                const truckOptions = Object.keys(truckCounts)
                    .map(truck => ({
                        value: truck,
                        text: `${this.packet.trucksdict[truck] || `Truck: ${truck}`} (${truckCounts[truck]})`,
                        count: truckCounts[truck]
                    }))
                    .sort((a, b) => b.count - a.count);

                this.availableTrucks = [
                    { value: null, text: '-- ALL TRUCKS --' },
                    ...truckOptions
                ];
            },

            processAvailablePickLocations() {
    const locationCounts = {};
    let filteredItems = this.allOrders;

    // Apply current filters except pick location filter
    if (this.selectedDate) {
        filteredItems = filteredItems.filter(item => item.delivery_date === this.selectedDate);
    }
    if (this.selected_state === 'open') {
        filteredItems = filteredItems.filter(item => item.status !== 1);
    } else if (this.selected_state) {
        filteredItems = filteredItems.filter(item => item.state == this.selected_state);
    }
    if (this.picked_pickup_truck) {
        filteredItems = filteredItems.filter(item => {
            const itemTruck = item.pickup_truck || item.truck;
            return itemTruck == this.picked_pickup_truck;
        });
    }
    if (this.selectedDropLocation) {
        filteredItems = filteredItems.filter(item => String(item.drop_location) === String(this.selectedDropLocation));
    }

    filteredItems.forEach(order => {
        const location = order.ship_locsub;
        if (location || location === 0) {
            const locationKey = String(location);
            if (!locationCounts[locationKey]) {
                locationCounts[locationKey] = 0;
            }
            locationCounts[locationKey]++;
        }
    });

    console.log('Available pick locations raw:', locationCounts); // Debug log

    const locationOptions = Object.keys(locationCounts)
        .map(location => {
            const displayText = this.getLocationDisplayWithSub(location);
            return {
                value: location,
                text: `${displayText} (${locationCounts[location]})`,
                count: locationCounts[location],
                rawValue: location
            };
        })
        .sort((a, b) => b.count - a.count);

    this.availablePickLocations = [
        { value: null, text: '-- ALL PICK LOCATIONS --' },
        ...locationOptions
    ];

    console.log('Available pick locations processed:', this.availablePickLocations); // Debug log
},
getLocationDisplayWithSub(locsub) {
    if (!locsub && locsub !== 0) return "N/A";

    const locsubStr = String(locsub);

    // Debug: Check what's in your locsubsdict
    console.log('Looking up locsub:', locsubStr, 'in locsubsdict:', this.packet.locsubsdict);

    // First try to get from locsubsdict (which should contain sublocations)
    if (this.packet.locsubsdict && this.packet.locsubsdict[locsubStr]) {
        const display = this.packet.locsubsdict[locsubStr];
        console.log('Found in locsubsdict:', display);
        return display;
    }

    // If not found, try to parse and display location + sublocation
    if (locsubStr.includes('|')) {
        const [locationId, sublocationId] = locsubStr.split('|');

        // Try to get location name
        let locationName = locationId;
        if (this.packet.locationsdict && this.packet.locationsdict[locationId]) {
            locationName = this.packet.locationsdict[locationId];
        }

        // Try to get sublocation name
        let sublocationName = sublocationId;
        if (this.packet.sublocationsdict && this.packet.sublocationsdict[sublocationId]) {
            sublocationName = this.packet.sublocationsdict[sublocationId];
        }

        const display = `${locationName} | ${sublocationName}`;
        console.log('Built display from parts:', display);
        return display;
    }

    // Fallback: try locationsdict
    if (this.packet.locationsdict && this.packet.locationsdict[locsubStr]) {
        return this.packet.locationsdict[locsubStr];
    }

    // Final fallback
    console.log('Using fallback for locsub:', locsubStr);
    return locsubStr;
},

            processAvailableDropLocations() {
                const locationCounts = {};
                let filteredItems = this.allOrders;

                // Apply current filters except drop location filter
                if (this.selectedDate) {
                    filteredItems = filteredItems.filter(item => item.delivery_date === this.selectedDate);
                }
                if (this.selected_state === 'open') {
                    filteredItems = filteredItems.filter(item => item.status !== 1);
                } else if (this.selected_state) {
                    filteredItems = filteredItems.filter(item => item.state == this.selected_state);
                }
                if (this.picked_pickup_truck) {
                    filteredItems = filteredItems.filter(item => {
                        const itemTruck = item.pickup_truck || item.truck;
                        return itemTruck == this.picked_pickup_truck;
                    });
                }
                if (this.selectedPickLocation) {
                    filteredItems = filteredItems.filter(item => String(item.ship_locsub) === String(this.selectedPickLocation));
                }

                filteredItems.forEach(order => {
                    const location = order.drop_location;
                    if (location || location === 0) {
                        const locationKey = String(location);
                        if (!locationCounts[locationKey]) {
                            locationCounts[locationKey] = 0;
                        }
                        locationCounts[locationKey]++;
                    }
                });

                const locationOptions = Object.keys(locationCounts)
                    .map(location => ({
                        value: location,
                        text: `${this.getLocationDisplay(location)} (${locationCounts[location]})`,
                        count: locationCounts[location]
                    }))
                    .sort((a, b) => b.count - a.count);

                this.availableDropLocations = [
                    { value: null, text: '-- ALL DROP LOCATIONS --' },
                    ...locationOptions
                ];
            },

            // Your other existing methods...
            getLocationDisplay: function(locsub) {
                if (!locsub && locsub !== 0) return "N/A";

                const locsubStr = String(locsub);

                if (locsubStr === "0") {
                    return "MECCA WHOLESALE";
                }

                let locationId;
                if (locsubStr.includes('|')) {
                    locationId = locsubStr.split('|')[0];
                } else {
                    locationId = locsubStr;
                }

                if (this.packet.locationsdict && this.packet.locationsdict[locationId]) {
                    return this.packet.locationsdict[locationId];
                }

                if (this.packet.locsubsdict && this.packet.locsubsdict[locsubStr]) {
                    return this.packet.locsubsdict[locsubStr];
                }

                const location = this.packet.locations.find(loc => loc.value == locationId);
                if (location) {
                    return location.text;
                }

                return locsubStr;
            },

            isTruckAssigned(item) {
                const hasTruck = item.truck &&
                                item.truck !== '' &&
                                item.truck !== '0' &&
                                item.truck !== 'null';
                return hasTruck;
            },

 getAvailableStates(item) {
    const currentState = parseInt(item.state);
    const hasTruck = this.isTruckAssigned(item);
    const userrole = this.packet.userDetails.userrole;

    console.log('Current state:', currentState, 'Has truck:', hasTruck, 'User role:', userrole);

    // Get ALL states to show to EVERYONE
    const allStates = this.states.map(state => ({
        ...state,
        // Add truck requirement message for positive states that need trucks
        text: [11, 13].includes(state.value) && !hasTruck ? 
              `${state.text} (TRUCK REQUIRED)` : state.text
    }));

    // Define which states are selectable based on business logic
    const getSelectableStates = () => {
        // For admin: ALL states are selectable
        if (userrole === "admin") {
            return allStates.map(state => state.value);
        }
        
        // For non-admin users: specific business logic
        const allowedStates = [11, -11, 13, -13]; // PICKED FROM MECCA SHIPPING, CANNOT BE PICKED, DROPPED AT STORE, CANNOT BE DROPPED
        
        // Only allow editing for specific workflow states
        if (![10, 11, -11, 13, -13].includes(currentState)) {
            return [currentState]; // Only current state
        }
        
        // Define which states can be selected from each current state
        if (currentState === 10) {
            // From DISPATCHED FOR STORE, can go to PICKED states
            return [11, -11];
        } else if ([11, -11].includes(currentState)) {
            // From PICKED states, can go to DROPPED states
            return [13, -13];
        } else if ([13, -13].includes(currentState)) {
            // From DROPPED states, end of workflow
            return [currentState];
        }
        
        // Default: only current state
        return [currentState];
    };

    const selectableStates = getSelectableStates();
    
    console.log('Selectable states:', selectableStates);

    // Return all states with proper enabling/disabling
    return allStates.map(state => {
        const isSelectable = selectableStates.includes(state.value);
        const isCurrentState = state.value === currentState;
        
        // Current state should always be enabled so it's visible
        if (isCurrentState) {
            return {
                ...state,
                disabled: false,
                // Optionally mark as current state
                text: `${state.text} (Current)`
            };
        }
        
        // Check truck requirement for positive states
        const needsTruck = [11, 13].includes(state.value);
        const canSelectWithTruck = isSelectable && (!needsTruck || (needsTruck && hasTruck));
        
        return {
            ...state,
            disabled: !canSelectWithTruck,
            // Add visual indicator if state requires truck
            text: needsTruck && !hasTruck ? 
                  `${state.text.split(' (TRUCK REQUIRED)')[0]} (TRUCK REQUIRED)` : 
                  state.text.split(' (TRUCK REQUIRED)')[0]
        };
    });
},

     isStateDisabled(item, stateValue) {
    const currentState = parseInt(item.state);
    const hasTruck = this.isTruckAssigned(item);
    const userrole = this.packet.userDetails.userrole;

    console.log('Checking if state disabled:', stateValue, 'Current:', currentState, 'Has truck:', hasTruck, 'User role:', userrole);

    // If user is admin, NEVER disable the state dropdown
    if (userrole === "admin") {
        console.log('Admin user - state enabled');
        return false;
    }

    // For non-admin users, use the existing logic
    // Only allow editing for specific workflow states
    if (![10, 11, -11, 13, -13].includes(currentState)) {
        console.log('State not in editable workflow');
        return true;
    }

    // Check truck requirement for positive states
    if ([11, 13].includes(stateValue) && !hasTruck) {
        console.log('State requires truck but no truck assigned');
        return true;
    }

    console.log('State is enabled');
    return false;
},

            getTruckDisplay(item) {
                if (this.outgoing_type == 'as_store_transfer_order') {
                    return "N/A";
                }

                const truckId = item.truck;

                if (!truckId || truckId === '' || truckId === '0' || truckId === 'null') {
                    return "NOT ASSIGNED";
                }

                return this.packet.trucksdict[truckId] || `Truck: ${truckId}`;
            },

            getStateDisplayText(stateValue) {
                const state = this.states.find(s => s.value === stateValue);
                return state ? state.text : 'UNKNOWN';
            },

            show_comments: function(item) {
                this.item_comments_invoice_id = item.invoice_id;
                this.item_comments_itemid = item.itemid;
                this.$bvModal.show("modal-comments");
            },

            update_invoice_item_state: function(item) {
    let path = "/api/sales/update_invoice_item_state/";
    let that = this;

    // Store original state for rollback
    const originalState = item.state;

    // Debug: Log what we have in the item
    console.log("Item data for update:", {
        invoice_id: item.invoice_id,
        outgoing_type: item.outgoing_type,
        order_type: item.order_type,
        state: item.state,
        product_sku: item.product_sku
    });

    // Determine incoming type from available data
    let incomingType = '';
    
    // Check for outgoing_type first (this seems to be the main field in this component)
    if (item.outgoing_type) {
        if (item.outgoing_type === 'STORE_TRANSFER_ORDER') {
            incomingType = 'STORE_TRANSFER_ORDER';
        } else if (item.outgoing_type === 'DAMAGE_ORDER') {
            incomingType = 'DAMAGE_ORDER';
        } else if (item.outgoing_type === 'CUSTOMER_ORDER') {
            incomingType = 'REGULAR_ORDER';
        }
    }
    // If not found, check order_type
    else if (item.order_type) {
        if (item.order_type === 'home_delivery' || item.order_type === 'store_pickup') {
            incomingType = 'REGULAR_ORDER';
        } else if (item.order_type === 'store_transfer') {
            incomingType = 'STORE_TRANSFER_ORDER';
        }
    }
    
    // If still not determined, check invoice_id pattern
    if (!incomingType && item.invoice_id) {
        const invoiceStr = item.invoice_id.toString().toUpperCase();
        if (invoiceStr.includes('TRANSFER') || invoiceStr.includes('TO')) {
            incomingType = 'STORE_TRANSFER_ORDER';
        } else if (invoiceStr.includes('DAMAGE') || invoiceStr.includes('DO')) {
            incomingType = 'DAMAGE_ORDER';
        } else {
            incomingType = 'REGULAR_ORDER';
        }
    }

    // Prepare data with all necessary fields
    let data = {
        invoice_id: item.invoice_id,
        itemid: item.itemid,
        state: item.state,
        changed_by: this.packet.userDetails.username,
        product_sku: item.product_sku,
        quantity: item.quantity,
        // Include location data
        pick_location: item.ship_locsub || item.original_locsub,
        ship_location: item.drop_locsub || item.drop_location,
        drop_location: item.drop_locsub || item.drop_location,
        original_locsub: item.original_locsub,
        ship_locsub: item.ship_locsub,
        // CRITICAL: Include incoming_type
        incoming_type: incomingType,
        // Include truck information
        pickup_truck: item.pickup_truck || item.truck,
        // Include outgoing_type as backup
        outgoing_type: item.outgoing_type
    };

    console.log("Sending update data to backend:", data);

    let s = function(response) {
        console.log("Backend response:", response.data);
        
        if (response.data.error) {
            that.$bvToast.toast(
                response.data.error,
                {title: "Error", autoHideDelay: 1500, variant:"warning"}
            );
            // Rollback to original state
            item.state = originalState;
            that.$forceUpdate();
        } else {
            that.$bvToast.toast(
                "Success updating item state.",
                {title: "Success", autoHideDelay: 1500, variant:"success"}
            );
            // Refresh data to get updated states
            setTimeout(() => {
                that.fetchAllOrders();
            }, 500);
        }
    }

    let f = function(error) {
        console.log("Request error:", error);
        that.$bvToast.toast(
            "Error updating item state.",
            {title: "Error", autoHideDelay: 1500, variant:"danger"}
        );
        // Rollback to original state
        item.state = originalState;
        that.$forceUpdate();
    }
    
    Requestor.postAsync(path, data, s, f);
},
            sortby: function(key, mapper) {
                if (this.sort_asc) {
                    this.items = Requestor.sort(this.items, key, mapper);
                } else {
                    this.items = Requestor.sort_reverse(this.items, key, mapper);
                }
                this.sort_asc = !this.sort_asc;
            },

            get_locations: function() {
                let output = [
                    {value: null, text: "PICK LOCATION", disabled: true}
                ];
                let user_location = this.packet.userDetails.properties.location_id;
                if (+user_location) {
                    output = this.packet.locations.filter(function(d) { return d.value == user_location });
                } else {
                    output = output.concat(this.packet.locations.filter(function(d) { return d.text != 'All' && d.value != 46 && d.value != 44 }));
                }
                return output;
            },

            fetchAllOrders() {
                let path = "/api/sales/get_outgoing_items_for_date_range2/";
                let that = this;
                this.startApiLoading('Fetching Outgoing Items');

                let data = {
                    date_range: this.date_range.filter(d => d !== null),
                    location_id: this.location_id
                };

                let s = function(response) {
                    if (response.data.result) {
                        that.allOrders = response.data.result;
                        that.items = response.data.result;
                        that.updateAvailableFilterOptions();
                    } else {
                        that.$bvToast.toast(
                            response.data.error,
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    that.items_being_loaded = false;
                    that.stopApiLoading();
                }

                let f = function(error) {
                    console.log(error);
                    that.$bvToast.toast(
                        "Error loading outgoing items.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.items_being_loaded = false;
                    that.stopApiLoading();
                }

                this.items_being_loaded = true;
                this.allOrders = [];
                this.items = [];
                Requestor.postSync(path, data, s, f);
            },
        },
        watch: {
            selected_state() {
        this.updateAvailableFilterOptions();
    },
    picked_pickup_truck() {
        this.updateAvailableFilterOptions();
    },
    selectedPickLocation() {
        this.updateAvailableFilterOptions();
    },
    selectedDropLocation() {
        this.updateAvailableFilterOptions();
    },
    selectedOrderType() {
        this.updateAvailableFilterOptions();
    }
        },
        created: function() {
            this.packet = JSON.parse(localStorage.packet);
            this.packet.userDetails = JSON.parse(localStorage.userDetails);
            this.trucks = this.packet.trucks;

            if (this.packet.userDetails.properties && this.packet.userDetails.properties.location_id) {
                let userLocation = this.packet.locations.find(item => [this.packet.userDetails.properties.location_id].includes(item.value));
                if (userLocation) {
                    this.location_id = userLocation.value;
                }
            }
        }
    }
</script>

<style scoped>
    /* Glass Theme Container */
    .incoming.glass-theme {
        position: relative;
        background: transparent !important;
        min-height: 100vh;
        padding: 24px;
    }

    /* Same background image */
    .incoming.glass-theme::before {
        content: '';
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-image: url('https://m.media-amazon.com/images/I/81eSegKonhL._AC_SL1500_.jpg');
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        filter: blur(10px);
        opacity: 0.5;
        z-index: -2;
        transform: scale(1.1);
    }

    /* Glass Card Effect */
    .glass-alert, .glass-filters, .glass-empty-alert {
        background: rgba(255, 255, 255, 0.85) !important;
        backdrop-filter: blur(10px) !important;
        border: 1px solid rgba(255, 255, 255, 0.3) !important;
        border-radius: 20px !important;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05) !important;
    }

    /* Glass Select */
    .glass-select {
        background: rgba(255, 255, 255, 0.9) !important;
        backdrop-filter: blur(5px) !important;
        border: 2px solid rgba(0, 0, 0, 0.1) !important;
        border-radius: 12px !important;
        transition: all 0.3s ease !important;
    }
    .glass-select:hover {
        background: rgba(255, 255, 255, 0.95) !important;
        border-color: rgba(0, 0, 0, 0.2) !important;
    }

    /* Glass Button */
    .glass-btn {
        background: linear-gradient(135deg, #28a745, #20c997) !important;
        border: none !important;
        color: white !important;
        transition: all 0.3s ease !important;
        border-radius: 12px !important;
        padding: 8px 20px !important;
    }
    .glass-btn:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 15px rgba(40, 167, 69, 0.3);
    }

    .glass-filter-btn {
        background: rgba(0, 123, 255, 0.1) !important;
        border: 1px solid rgba(0, 123, 255, 0.3) !important;
        color: #007bff !important;
        border-radius: 12px !important;
        transition: all 0.3s ease !important;
    }
    .glass-filter-btn:hover {
        background: rgba(0, 123, 255, 0.2) !important;
        transform: scale(1.02);
    }

    /* Glass Comment Button */
    .glass-comment-btn {
        background: rgba(0, 123, 255, 0.1);
        border: 1px solid rgba(0, 123, 255, 0.3);
        color: #007bff;
        padding: 5px 10px;
        border-radius: 8px;
        cursor: pointer;
        transition: all 0.3s ease;
    }
    .glass-comment-btn:hover {
        background: rgba(0, 123, 255, 0.2);
        transform: scale(1.05);
    }

    /* Glass Status Select */
    .glass-status-select {
        border-radius: 8px !important;
        transition: all 0.3s ease !important;
    }
    .glass-status-select:hover {
        transform: scale(1.02);
    }

    /* Glass Table */
    .glass-table {
        border-collapse: separate;
        border-spacing: 0;
        width: 100%;
    }
    .glass-table-header {
        background: rgba(60, 60, 60, 0.9) !important;
        backdrop-filter: blur(5px);
        padding: 12px !important;
    }
    .glass-table-row {
        transition: all 0.3s ease;
    }
    .glass-table-row:hover {
        background: rgba(255, 255, 255, 0.7) !important;
        transform: scale(1.01);
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    }

    /* Loading Overlay */
    .loading-overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.85);
        backdrop-filter: blur(20px);
        z-index: 2000;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .loading-overlay-enter-active { animation: fadeIn 0.3s ease; }
    .loading-overlay-leave-active { animation: fadeOut 0.3s ease; }
    @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
    @keyframes fadeOut { from { opacity: 1; } to { opacity: 0; } }

    .loading-card {
        background: linear-gradient(135deg, rgba(255, 255, 255, 0.95), rgba(245, 245, 245, 0.95));
        border-radius: 24px;
        padding: 48px 56px;
        text-align: center;
        box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);
        animation: cardPop 0.5s cubic-bezier(0.68, -0.55, 0.265, 1.55);
        max-width: 450px;
        width: 90%;
    }
    @keyframes cardPop { from { opacity: 0; transform: scale(0.8); } to { opacity: 1; transform: scale(1); } }

    .loading-animation { margin-bottom: 32px; }
    .loading-ring { position: relative; width: 100px; height: 100px; margin: 0 auto; display: flex; align-items: center; justify-content: center; }
    .ring { position: absolute; width: 100%; height: 100%; border: 4px solid transparent; border-radius: 50%; animation: ringRotate 1.5s linear infinite; }
    .ring:nth-child(1) { border-top-color: #4299e1; border-left-color: #4299e1; animation-duration: 1s; }
    .ring:nth-child(2) { border-right-color: #48bb78; border-bottom-color: #48bb78; width: 80%; height: 80%; top: 10%; left: 10%; animation-duration: 1.2s; animation-direction: reverse; }
    .ring:nth-child(3) { border-left-color: #ed8936; border-bottom-color: #ed8936; width: 60%; height: 60%; top: 20%; left: 20%; animation-duration: 0.8s; }
    @keyframes ringRotate { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }

    .loading-logo { font-size: 32px; font-weight: bold; animation: logoPulse 1.5s ease-in-out infinite; z-index: 1; }
    .loading-logo i { font-size: 40px; background: linear-gradient(135deg, #4299e1, #48bb78); -webkit-background-clip: text; background-clip: text; color: transparent; }
    @keyframes logoPulse { 0%, 100% { transform: scale(1); opacity: 0.7; } 50% { transform: scale(1.1); opacity: 1; } }

    .loading-text { margin-bottom: 24px; }
    .loading-text h3 { color: #2d3748; font-size: 1.3rem; margin-bottom: 8px; display: inline-block; }
    .loading-dots { display: inline-flex; margin-left: 8px; }
    .loading-dots .dot { width: 6px; height: 6px; background: #4299e1; border-radius: 50%; margin: 0 2px; animation: dotBounce 1.4s ease-in-out infinite; }
    .loading-dots .dot:nth-child(1) { animation-delay: 0s; }
    .loading-dots .dot:nth-child(2) { animation-delay: 0.2s; }
    .loading-dots .dot:nth-child(3) { animation-delay: 0.4s; }
    @keyframes dotBounce { 0%, 60%, 100% { transform: translateY(0); } 30% { transform: translateY(-8px); } }

    .loading-progress { width: 100%; height: 4px; background: #e2e8f0; border-radius: 4px; overflow: hidden; margin-bottom: 20px; }
    .progress-bar { height: 100%; background: linear-gradient(90deg, #4299e1, #48bb78, #ed8936, #4299e1); background-size: 200% 100%; animation: progressShine 1.5s linear infinite; transition: width 0.3s ease; border-radius: 4px; }
    @keyframes progressShine { 0% { background-position: 200% 0; } 100% { background-position: -200% 0; } }

    .loading-tips { margin-top: 20px; }
    .tip-text { color: #718096; font-size: 0.9rem; animation: tipFade 0.5s ease; }
    @keyframes tipFade { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }

    /* Existing styles */
    .diver {
        overflow: auto;
        width: 100%;
        height: 800px;
    }
    .srr {
        font-size: 12px;
        text-align: center;
        font-weight: bold;
        background: rgb(60, 60, 60);
        color: white;
        border: 1px solid #ffffff;
    }

    .srrv {
        font-size: 13px;
        text-align: center;
        background: white;
        border: 1px solid #010101;
        padding: 5px;
    }
    table {
        table-layout: fixed;
        width: 100%;
    }
    .ipt_tdr {
        background: none;
        text-align: center;
        font-size: 13px;
    }

    .ipt_tdhr {
        background: #343a40;
        color: white;
        font-weight: bold;
        text-align: center;
        font-size: 13px;
        border: 1px solid white;
    }
    @media (max-width: 768px) {
        .incoming.glass-theme {
            padding: 16px;
        }
        .diver {
            height: auto;
            overflow-x: auto;
            overflow-y: auto;
        }
        .glass-btn {
            margin-top: 10px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/IncomingOutGoing/StoreTransfer.vue